






























































































































































































import Vue from "vue";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import store, { CashPreAccEditorStore } from "../services/CashPreAccEditorStore";
import { CashPreAccDimCode, CashPreAccEditItem } from "../models/CashPreAccEditing";
import LookupComboBox from "@/components/LookupComboBox.vue";

interface Data {
  store: CashPreAccEditorStore;
}

interface Methods {
  onRowClick(item: any): void;
  onValueChanged(item: CashPreAccEditItem): void;
  dimCodes(type: number): CashPreAccDimCode[];
  detailedTypeName(id: number): string;
  onAccNoValueChanged(item: CashPreAccEditItem, newValue: any): void;
  onDimCodeValueChanged(item: CashPreAccEditItem, field: string, newValue: any): void;
  setSelectedElements(item: CashPreAccEditItem): void;
}

interface Computed {
  items: CashPreAccEditItem[];
  itemsTotalValue: string;
  itemsTotalNegativeValue: string;
  itemsTotalPositiveValue: string;
  sideAccSign: string;
}

interface Props {
  positiveNegative: string;
  columns: any[];
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    MoneyDisplay,
    LookupComboBox,
  },
  props: {
    // 'negative' = Tartozik ('+', bal oldal), 'positive' = Követel ('-', jobb oldal),
    // 'both' = egy táblás nézet (minden tétel)
    positiveNegative: { type: String },
    columns: {type: Array, required: true},
  },
  data() {
    return {
      store,
    };
  },
  computed: {
    sideAccSign(){
      return this.$props.positiveNegative == "positive" ? "-" : "+";
    },
    items(){
      return this.store.items.filter((x: CashPreAccEditItem) =>
        this.$props.positiveNegative == "both" ? true : x.accSign == this.sideAccSign
      ).map(item =>
        {
          item.selected = item === this.store.selectedItem;
          item.inEdit = item === this.store.selectedItem;
          return item;
        });
    },
    itemsTotalValue(){
      return new Intl.NumberFormat('hu-HU').format(this.items.reduce((currentSumNumber: number, arrayItem: CashPreAccEditItem) => currentSumNumber + Number(arrayItem.total), 0));
    },
    itemsTotalNegativeValue(){
      return new Intl.NumberFormat('hu-HU').format(this.items.filter(x => x.accSign == "+").reduce((currentSumNumber: number, arrayItem: CashPreAccEditItem) => currentSumNumber + Number(arrayItem.total), 0));
    },
    itemsTotalPositiveValue(){
      return new Intl.NumberFormat('hu-HU').format(this.items.filter(x => x.accSign == "-").reduce((currentSumNumber: number, arrayItem: CashPreAccEditItem) => currentSumNumber + Number(arrayItem.total), 0));
    },
  },
  methods: {
    onRowClick(event){
      this.store.selectedItem = event.dataItem;
    },
    setSelectedElements(item){
      if(item.accSign == "-"){
        this.store.positiveSelectedItem = item;
      }
      else{
        this.store.negativeSelectedItem = item;
      }
    },
    onValueChanged(item){
      this.store.syncModified(item);
    },
    dimCodes(type){
      return this.store.dimCodes.filter((i: CashPreAccDimCode) => i.type == type)
    },
    detailedTypeName(id){
      return this.store.detailedTypes.find(x => x.id == id)?.name ?? String(id);
    },
    // Guard: a LookupComboBox Enter-re csonk objektumot is kiadhat (ismert,
    // halasztott hiba) — undefined értéket nem írunk a modellbe, mert az a
    // mentéskor néma adatvesztést okozna
    onAccNoValueChanged(item,newValue){
      if (!newValue || newValue.accNo === undefined) return;
      item.accCode = newValue.accNo;
      item.accCodeName = newValue.name;
    },
    onDimCodeValueChanged(item,field,newValue){
      if (!newValue || newValue.dimcode === undefined) return;
      (item as any)[field] = newValue.dimcode;
    },
  },
  watch:{
    'store.selectedItem'(item) {
      if(this.$props.positiveNegative == "both" || item.accSign == this.sideAccSign){
        this.setSelectedElements(item);
      }
    },
  }
});
